import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';

export const ImprimirMIJMFBCV = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const efiscalanio = JSON.parse(localStorage.getItem('efiscalanio'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [report, setReport] = useState('');
    const [fecha, setFecha] = useState('');
    const [parametro, setParametro] = useState('');
    const [tipo, setTipo] = useState('');
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtFecha = useRef();
    const txtChk1 = useRef();
    const txtChk2 = useRef();
    const txtChk3 = useRef();
    const txtChk4 = useRef();

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtFecha.current.value === "") {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha Desde no debe ir Vacio!', icono: 'informacion' });
            sigue = false;
            txtFecha.current.focus();
        }

        else if (sigue) {
            imprimirGeneral(fecha)
        }

    };

    const onChange = (e) => {

        if (e.target.id === 'fecha') {
            setFecha(e.target.value);
        }
    };

    const onCheck = () => {

        if (txtChk1.current.checked) {
            setTipo(3);
            setParametro('Comprometido');
            setActivo(false);
        } else if (txtChk2.current.checked) {
            setTipo(1);
            setParametro('Causado');
            setActivo(false);
        } else if (txtChk3.current.checked) {
            setTipo(2);
            setParametro('Pagado');
            setActivo(false);
        } else if (txtChk4.current.checked) {
            setTipo(0);
            setActivo(false);
        }

    }

    const imprimirGeneral = (fecha) => {
        
        let fech = moment.utc(fecha).format('DD-MM-YYYY');
        let fechaval = "";
        var reporte = "";
        let condi;
        var sequuencia = "";
        let val = 0;
        if (props.condicion === 'MIJ_01' || props.condicion === 'MIJ_02' || props.condicion === 'BCV_F3' || props.condicion === 'BCV_F6') {
            reporte = 'Pres_PAR_MovGtos_Estatal';
            fechaval = "al Día" + " " + "'" + fech + "'";
            condi = ("01" + "-" + "01" + "-" + fech.substring(6, 10));
            sequuencia = tipo;
            val = 1;
        } else if (props.condicion === 'MF_00') {
            reporte = 'Pres_Mov_Trim';
            fechaval = "al Día" + " " + "'" + fech + "'";
            condi = ("01" + "-" + "01" + "-" + fech.substring(6, 10));
            sequuencia = parametro;
            val = 2;
        }

        window.open(op.reportes + "/contabilidadpresupuestaria?" + "reporte=" + reporte + "&sql1=" + idefiscal + "&sql2=" + fech + "&sql3=" + fechaval + "&sql4=" + condi + "&tipo=" + sequuencia + "&val=" + val, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        txtFecha.current.value = '';
        setActivo(true);
    };


    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquear();
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                txtFecha.current.value = moment.utc(fechaSistema).format('YYYY-MM-DD');
                let fech = moment.utc(fechaSistema).format('YYYY-MM-DD');
                setFecha(fech);
            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{'Imprimir'+' '+props.condicion}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className='container-fluid rounded'>

                    <div className="tab-content" id="ex-with-icons-content">
                        <div className="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="ex-with-icons-tab-1">

                            <fieldset className="row border-azul rounded mx-auto">
                            <legend className="float-none m-0 w-auto" >Datos</legend>

                                <div className='row m-0 px-0 mb-2'>

                                    <div className='col-sm-5 mb-1 px-1 mx-auto'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Al Día:</label>
                                            <input type="date" className="form-control text-uppercase text-center" onChange={onChange} ref={txtFecha} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="fecha" />
                                        </div>
                                    </div>

                                </div>
                                {props.condicion === 'MIJ_01' ? <div className='row m-0 px-0 col-md-11 mx-auto'>
                                    <div className="form-check col-md-4 ml-auto">
                                        <input className="form-check-input" ref={txtChk1} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                        <label className="form-check-label" for="flexRadioDefault1">
                                            Gastos Capital
                                        </label>
                                    </div>
                                    <div className="form-check col-md-4 ml-auto">
                                        <input className="form-check-input" ref={txtChk2} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                                        <label className="form-check-label" for="flexRadioDefault2">
                                            Gastos Corrientes
                                        </label>
                                    </div>
                                    <div className="form-check col-md-4 ml-auto">
                                        <input className="form-check-input" ref={txtChk3} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault3" />
                                        <label className="form-check-label" for="flexRadioDefault3">
                                            Aplicaciones Financieras
                                        </label>
                                    </div>
                                </div> : props.condicion === 'MIJ_02' ? <div className='row m-0 px-0 col-md-11 mx-auto'>
                                    <div className="form-check col-md-3 ml-auto">
                                        <input className="form-check-input" ref={txtChk1} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                        <label className="form-check-label" for="flexRadioDefault1">
                                            Gastos Capital
                                        </label>
                                    </div>
                                    <div className="form-check col-md-3 ml-auto">
                                        <input className="form-check-input" ref={txtChk2} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                                        <label className="form-check-label" for="flexRadioDefault2">
                                            Gastos Corrientes
                                        </label>
                                    </div>
                                    <div className="form-check col-md-4 ml-auto">
                                        <input className="form-check-input" ref={txtChk3} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault3" />
                                        <label className="form-check-label" for="flexRadioDefault3">
                                            Aplicaciones Financieras
                                        </label>
                                    </div>
                                    <div className="form-check col-md-2 ml-auto">
                                        <input className="form-check-input" ref={txtChk4} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault4" />
                                        <label className="form-check-label" for="flexRadioDefault4">
                                            General
                                        </label>
                                    </div>
                                </div> : props.condicion === 'MF_00' ? <div className='row m-0 px-0 col-md-12 mx-auto'>
                                    <div className="form-check col-md-4 ml-auto">
                                        <input className="form-check-input" ref={txtChk1} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                        <label className="form-check-label" for="flexRadioDefault1">
                                            Movimientos Comprometidos
                                        </label>
                                    </div>
                                    <div className="form-check col-md-4 ml-auto">
                                        <input className="form-check-input" ref={txtChk2} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                                        <label className="form-check-label" for="flexRadioDefault2">
                                            Movimientos Causados
                                        </label>
                                    </div>
                                    <div className="form-check col-md-3 ml-auto px-0">
                                        <input className="form-check-input" ref={txtChk3} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault3" />
                                        <label className="form-check-label" for="flexRadioDefault3">
                                            Movimientos Pagados
                                        </label>
                                    </div>
                                </div> : props.condicion === 'BCV_F3' ? <div className='row m-0 px-0 col-md-11 mx-auto'>
                                    <div className="form-check col-md-4 ml-auto">
                                        <input className="form-check-input" ref={txtChk1} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                        <label className="form-check-label" for="flexRadioDefault1">
                                            Gastos Capital
                                        </label>
                                    </div>
                                    <div className="form-check col-md-4 ml-auto">
                                        <input className="form-check-input" ref={txtChk2} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                                        <label className="form-check-label" for="flexRadioDefault2">
                                            Gastos Corrientes
                                        </label>
                                    </div>
                                    <div className="form-check col-md-4 ml-auto">
                                        <input className="form-check-input" ref={txtChk3} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault3" />
                                        <label className="form-check-label" for="flexRadioDefault3">
                                            Aplicaciones Financieras
                                        </label>
                                    </div>
                                </div> : props.condicion === 'BCV_F6' ? <div className='row m-0 px-0 col-md-11 mx-auto'>
                                    <div className="form-check col-md-4 ml-auto">
                                        <input className="form-check-input" ref={txtChk1} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                        <label className="form-check-label" for="flexRadioDefault1">
                                            Gastos Capital
                                        </label>
                                    </div>
                                    <div className="form-check col-md-4 ml-auto">
                                        <input className="form-check-input" ref={txtChk2} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                                        <label className="form-check-label" for="flexRadioDefault2">
                                            Gastos Corrientes
                                        </label>
                                    </div>
                                    <div className="form-check col-md-4 ml-auto">
                                        <input className="form-check-input" ref={txtChk3} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault3" />
                                        <label className="form-check-label" for="flexRadioDefault3">
                                            Aplicaciones Financieras
                                        </label>
                                    </div>
                                </div> : ''
                                }


                            </fieldset>

                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} disabled={activo} onClick={onChangeValidar} style={{ margin: '1px' }} className="btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Imprimir</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>

    );
}